export const toast = {
  methods: {
    show_toast (type, title, msg) {
      window.toastr.options = {
        closeButton: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        onclick: null
      }
      let $toast = window.toastr[type](msg, title)
      this.lasttoast = $toast
    }
  }
}
